import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onClickSubmit: () => void
}

const DeleteAssignmentModal = ({ onClickSubmit }: Props) => {
  return (
    <Modal
      illustration="delete-cross"
      title={i18n.t('time_off.policy_timeline.delete_assignment.title')}
      description={i18n.t('time_off.policy_timeline.delete_assignment.confirm')}
      onSubmit={onClickSubmit}
      footer={
        <Button type="negative" submit>
          {i18n.t('common.destroy')}
        </Button>
      }
    />
  )
}

export default DeleteAssignmentModal
